// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoice-wrapper {
  background-color: #f8f9fa;
  min-height: 100vh;
  padding: 20px 0;
}

.invoice-container {
  max-width: 800px;
  margin: 0 auto;
  border: 1px solid #e0e0e0;
  color: #333;
  font-family:
    "Inter",
    system-ui,
    -apple-system,
    sans-serif;
  padding: 30px !important; /* Reduced padding */
}

.invoice-logo {
  max-height: 50px; /* Smaller logo */
}

.brand-name {
  color: #1a73e8;
  font-weight: 800;
  letter-spacing: -1px;
  font-size: 1.25rem; /* Smaller brand name */
}

.invoice-title {
  font-size: 2.2rem; /* Smaller title */
  font-weight: 900;
  color: #dbdce0;
  margin-bottom: 0;
}

.invoice-id {
  font-weight: 600;
  color: #666;
  font-size: 0.9rem;
}

.divider {
  border-top: 2px solid #f0f0f0;
  margin: 20px 0; /* Reduced margin */
}

.section-title {
  color: #1a73e8;
  font-size: 0.75rem; /* Smaller section title */
  font-weight: 700;
  letter-spacing: 1px;
  margin-bottom: 10px;
}

.info-box p {
  margin-bottom: 2px; /* Tighter line height */
  font-size: 0.9rem;
}

.invoice-table {
  border-collapse: separate;
  border-spacing: 0 5px;
}

.invoice-table thead th {
  background-color: #f8f9fa;
  border: none;
  color: #666;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  padding: 10px;
}

.invoice-table tbody td {
  border-top: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  padding: 12px 10px; /* Reduced cell padding */
  background: #fff;
  font-size: 0.9rem;
}

.summary-card {
  background-color: #fdfdfd;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 15px !important;
  font-size: 0.9rem;
}

.total-row {
  font-size: 1.1rem;
  color: #202124;
}

.thanks {
  font-size: 1rem;
  font-weight: 600;
  color: #1a73e8;
  margin-bottom: 5px;
}

.contact-info {
  font-size: 0.8rem;
  color: #666;
}

.btn-print {
  border-radius: 30px;
  font-weight: 600;
  box-shadow: 0 4px 15px rgba(26, 115, 232, 0.3);
  transition: transform 0.2s;
}

/* Margins for the main elements removed to save vertical space */
.mb-5 {
  margin-bottom: 1.5rem !important;
}

@media print {
  @page {
    margin: 0; /* Hides browser headers (Title) and footers (URL/Copyright) */
  }

  body {
    margin: 1.5cm; /* Adds clean margin to the actual content */
    background-color: #fff;
  }

  .no-print,
  footer,
  .navbar {
    display: none !important;
  }

  .invoice-wrapper {
    padding: 0;
    background-color: #fff;
    min-height: auto;
  }

  .invoice-container {
    border: none;
    box-shadow: none !important;
    max-width: 100%;
    padding: 0 !important;
    margin: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/invoice/invoice.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX;;;;cAIY;EACZ,wBAAwB,EAAE,oBAAoB;AAChD;;AAEA;EACE,gBAAgB,EAAE,iBAAiB;AACrC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB,EAAE,uBAAuB;AAC7C;;AAEA;EACE,iBAAiB,EAAE,kBAAkB;EACrC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,cAAc;EACd,kBAAkB,EAAE,0BAA0B;EAC9C,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB,EAAE,wBAAwB;EAC5C,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB,EAAE,yBAAyB;EAC7C,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;EAC9C,0BAA0B;AAC5B;;AAEA,iEAAiE;AACjE;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,SAAS,EAAE,8DAA8D;EAC3E;;EAEA;IACE,aAAa,EAAE,4CAA4C;IAC3D,sBAAsB;EACxB;;EAEA;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,2BAA2B;IAC3B,eAAe;IACf,qBAAqB;IACrB,SAAS;EACX;AACF","sourcesContent":[".invoice-wrapper {\n  background-color: #f8f9fa;\n  min-height: 100vh;\n  padding: 20px 0;\n}\n\n.invoice-container {\n  max-width: 800px;\n  margin: 0 auto;\n  border: 1px solid #e0e0e0;\n  color: #333;\n  font-family:\n    \"Inter\",\n    system-ui,\n    -apple-system,\n    sans-serif;\n  padding: 30px !important; /* Reduced padding */\n}\n\n.invoice-logo {\n  max-height: 50px; /* Smaller logo */\n}\n\n.brand-name {\n  color: #1a73e8;\n  font-weight: 800;\n  letter-spacing: -1px;\n  font-size: 1.25rem; /* Smaller brand name */\n}\n\n.invoice-title {\n  font-size: 2.2rem; /* Smaller title */\n  font-weight: 900;\n  color: #dbdce0;\n  margin-bottom: 0;\n}\n\n.invoice-id {\n  font-weight: 600;\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.divider {\n  border-top: 2px solid #f0f0f0;\n  margin: 20px 0; /* Reduced margin */\n}\n\n.section-title {\n  color: #1a73e8;\n  font-size: 0.75rem; /* Smaller section title */\n  font-weight: 700;\n  letter-spacing: 1px;\n  margin-bottom: 10px;\n}\n\n.info-box p {\n  margin-bottom: 2px; /* Tighter line height */\n  font-size: 0.9rem;\n}\n\n.invoice-table {\n  border-collapse: separate;\n  border-spacing: 0 5px;\n}\n\n.invoice-table thead th {\n  background-color: #f8f9fa;\n  border: none;\n  color: #666;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  padding: 10px;\n}\n\n.invoice-table tbody td {\n  border-top: 1px solid #f0f0f0;\n  border-bottom: 1px solid #f0f0f0;\n  padding: 12px 10px; /* Reduced cell padding */\n  background: #fff;\n  font-size: 0.9rem;\n}\n\n.summary-card {\n  background-color: #fdfdfd;\n  border: 1px solid #f0f0f0;\n  border-radius: 8px;\n  padding: 15px !important;\n  font-size: 0.9rem;\n}\n\n.total-row {\n  font-size: 1.1rem;\n  color: #202124;\n}\n\n.thanks {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #1a73e8;\n  margin-bottom: 5px;\n}\n\n.contact-info {\n  font-size: 0.8rem;\n  color: #666;\n}\n\n.btn-print {\n  border-radius: 30px;\n  font-weight: 600;\n  box-shadow: 0 4px 15px rgba(26, 115, 232, 0.3);\n  transition: transform 0.2s;\n}\n\n/* Margins for the main elements removed to save vertical space */\n.mb-5 {\n  margin-bottom: 1.5rem !important;\n}\n\n@media print {\n  @page {\n    margin: 0; /* Hides browser headers (Title) and footers (URL/Copyright) */\n  }\n\n  body {\n    margin: 1.5cm; /* Adds clean margin to the actual content */\n    background-color: #fff;\n  }\n\n  .no-print,\n  footer,\n  .navbar {\n    display: none !important;\n  }\n\n  .invoice-wrapper {\n    padding: 0;\n    background-color: #fff;\n    min-height: auto;\n  }\n\n  .invoice-container {\n    border: none;\n    box-shadow: none !important;\n    max-width: 100%;\n    padding: 0 !important;\n    margin: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
